import { render, staticRenderFns } from "./ConfigAreaRisk.vue?vue&type=template&id=01c715d6&"
import script from "./ConfigAreaRisk.vue?vue&type=script&lang=js&"
export * from "./ConfigAreaRisk.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAreaRisk.vue?vue&type=style&index=0&id=01c715d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports